import {Injectable} from '@angular/core';
import {SentryErrorHandler} from "@sentry/angular";

@Injectable()
export class GlobalErrorHandler extends SentryErrorHandler {

  private readonly messages = [
    'error loading dynamically imported module',
    'Failed to fetch dynamically imported module'
  ];

  constructor() {
    super({showDialog: false});
  }

  override handleError(error: Error): void {
    if (error && error.message && this.messages.some(m => error.message.includes(m))) {
      // @ts-ignore
      window.location.reload(true);
      return;
    }
    return super.handleError(error);
  }
}
